<template>
  <div>
    <div class="app-title">
      <div>
        <h1><i class="fas fa-list"></i> Report</h1>
        <p>[{{ name }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-4">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <!-- <li class="nav-item">
            <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              Dropdown
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">Action</a>
              <a class="dropdown-item" href="#">Another action</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#">Something else here</a>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled">Disabled</a>
          </li> -->
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <div class="form-group mr-2">
            <label class="mr-2" for="inputGroupSelect01"
              >ค้นหาเจ้าหน้าที่</label
            >
            <select class="custom-select" id="inputGroupSelect01">
              <option selected>เลือก...</option>
              <option
                :value="item.id"
                v-for="(item, index) in users"
                :key="index"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
          <button class="btn btn-outline-success my-2 my-sm-0" type="submit">
            ค้นหา
          </button>
        </form>
      </div>
    </nav>
    <!-- <div class="row">
      <div class="col-md-12">
        <div class="input-group mb-3 col-md-4 p-0">
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect01"
              >เจ้าหน้าที่</label
            >
          </div>
          <select class="custom-select" id="inputGroupSelect01">
            <option selected>เลือก...</option>
            <option
              :value="item.id"
              v-for="(item, index) in users"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">Title</h3>
            <p>
              <button
                @click="print"
                type="button"
                class="btn btn-outline-success"
              >
                <i class="fas fa-print"></i> Print
              </button>
            </p>
          </div>
          <div class="tile-body">
            <form action="">
              <div class="form-group">
                <label for=""></label>
                <input type="text"
                  class="form-control" name="" id="" aria-describedby="helpId" placeholder="">
                <small id="helpId" class="form-text text-muted">Help text</small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairsService from "../services/repairs.service";
import UsersService from "../services/users.service";

import _ from "lodash";
export default {
  data() {
    return {
      repairs: "",
      users: "",
      name: this.$route.name,
    };
  },
  methods: {
    get() {
      RepairsService.getAll()
        .then((res) => {
          this.repairs = res.data;
        })
        .catch((err) => {});
    },
    getUsers() {
      UsersService.getAll()
        .then((res) => {
          this.users = res.data;
        })
        .catch((err) => {});
    },
    data_(id = 1) {
      return _.filter(this.repairs.data, function (o) {
        return o.user_id == id;
      });
    },
    async print() {
      // Pass the element id here
      await this.$htmlToPaper("printMe");
    },
  },
  computed: {
    dataRepairs() {
      return _.filter(this.repairs.data, function (o) {
        return o.user_id == 1;
      });
    },
  },
  created() {
    this.get();
    this.getUsers();
  },
};
</script>

<style>
p {
  margin: 0px;
}
@media print {
  body * {
    visibility: hidden;
  }
  #section-to-print,
  #section-to-print * {
    visibility: visible;
  }
  #section-to-print {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>